/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Generated on Tuesday, June 24, 2025 9:10:01 PM UTC
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IWorkflowsInputCreate,
  IWorkflowsInputEditNameAndDescription,
  IWorkflowsInputModifyStatuses,
  IWorkflowsInputUpdateStatusTransitions,
  IWorkflowsInputModifyJobs,
} from '../types/request.types'
import {
  IStatusForSelection,
  IWorkflowForSelection,
  IWorkflowsOutputDetail,
  IProjectWithAccessType,
  IPostSuccess,
  IGenericJSONMessage,
} from '../types/response.types'

export default new class WorkflowsAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Statuses(
    workflow_id: any,
  ): Promise<IStatusForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/statuses`,
    })
  }
  public async get_ForSelection(
  ): Promise<IWorkflowForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/workflows/for-selection`,
    })
  }
  public async get_Detail(
    workflow_id: any,
  ): Promise<IWorkflowsOutputDetail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}`,
    })
  }
  public async get_Projects(
    workflow_id: any,
  ): Promise<IProjectWithAccessType[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/projects`,
    })
  }
  /****** POST methods *****/
  public async post_Create(
    data: IWorkflowsInputCreate,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/workflows`,
      data,
    })
  }
  public async post_Clone(
    workflow_id: any,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/clone`,
    })
  }
  /****** PUT methods *****/
  public async put_EditNameAndDescription(
    workflow_id: any,
    data: IWorkflowsInputEditNameAndDescription,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/name-and-description`,
      data,
    })
  }
  public async put_Publish(
    workflow_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/publish`,
    })
  }
  public async put_Unpublish(
    workflow_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/unpublish`,
    })
  }
  public async put_ModifyStatuses(
    workflow_id: any,
    data: IWorkflowsInputModifyStatuses,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/statuses`,
      data,
    })
  }
  public async put_UpdateStatusTransitions(
    workflow_id: any,
    data: IWorkflowsInputUpdateStatusTransitions,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/status-transitions`,
      data,
    })
  }
  public async put_ModifyJobs(
    workflow_id: any,
    data: IWorkflowsInputModifyJobs,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}/jobs`,
      data,
    })
  }
  /****** DELETE methods *****/
  public async delete_Delete(
    workflow_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/workflows/${workflow_id}`,
    })
  }
}()
